var exports = {
  "nM": "x127c5a35--ff5905--row",
  "Uk": "x127c5a35--ff5905--filters-container",
  "xB": "x127c5a35--ff5905--filters-title",
  "wd": "x127c5a35--ff5905--filters-buttons",
  "HG": "x127c5a35--ff5905--chipsbox-wrapper",
  "Am": "x127c5a35--ff5905--footer-modal",
};

module.exports = exports;
